export enum URL_API {
  LOGIN = "https://event-service.aimacademy.vn/api/checkin/login",
  SCAN = "https://event-service.aimacademy.vn/api/checkin/check_code",
  ACCEPT = "https://event-service.aimacademy.vn/api/checkin/accept_code",
}
